module.exports = __webpack_public_path__ + "static/media/bluMangoes.5fe38981.png";